import { Immutable } from "immer";
import React from "react";
import { CartReferenceNumber } from "tsi-common-react/src/apps/checkout/CartReferenceNumber";
import { t } from "ttag";

import { templates } from "@reactivated";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<templates.CheckoutHeaderTemplate>;

export const CheckoutHeader = (props: IProps): React.JSX.Element => {
    const secureCheckout = richT(t`<secure>secure</secure> checkout`, {
        secure: (children) => <span>{children}</span>,
    });
    return (
        <header className={concatClassNames([styles.checkoutHeader, "header"])}>
            <a href={props.root_page_url}>
                <svg
                    className="desktop-only"
                    role="img"
                    aria-labelledby="desktop-only-logo"
                >
                    <title id="desktop-only-logo">{t`Sealy Homepage`}</title>
                    <use xlinkHref="#bowtie" />
                </svg>
            </a>

            <a
                className={styles.siteNavLogoLinkMobile}
                href={props.root_page_url}
            >
                <svg
                    className="mobile-only"
                    role="img"
                    aria-labelledby="mobile-only-logo"
                >
                    <title id="mobile-only-logo">{t`Sealy Homepage`}</title>
                    <use xlinkHref="#wordmark" />
                </svg>
            </a>

            <h1>{secureCheckout}</h1>

            <div className={styles.checkoutHeaderCartRef}>
                <CartReferenceNumber
                    encodedBasketID={props.encoded_basket_id}
                    phoneNumber={props.support_website_phone_number}
                />
            </div>
        </header>
    );
};
